// extracted by mini-css-extract-plugin
export default {"not-found-wrapper":"PageNotFound_not-found-wrapper__fREM-","info":"PageNotFound_info__ZBnme"};